import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/translation/fallback/translation.fallback.query.gql"
import type {
  TranslationFallbackQuery,
  TranslationFallbackQueryVariables,
} from "@/v2-backoffice-client/translation/fallback/__types__/translation.fallback.query"

type Options = QueryHookOptions<
  TranslationFallbackQuery,
  TranslationFallbackQueryVariables
>

export function useTranslationFallbackQuery(options?: Options) {
  return useQuery<TranslationFallbackQuery, TranslationFallbackQueryVariables>(
    query,
    options,
  )
}
